<template>
  <div class="image-input">
    <input
      type="file"
      style="display: none"
      ref="fileInputElement"
      @change="pickFile"
    />
    <p>{{ fileName && fileName }}</p>
    <button
      type="button"
      class="btn btn-outline-light px-5 rounded-pill"
      @click="openFilePicker"
    >
      Enviar novo
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fileName: null
    };
  },
  methods: {
    openFilePicker() {
      this.$refs.fileInputElement.click();
    },
    pickFile() {
      const selectedFile = this.$refs.fileInputElement.files[0];
      this.fileName = selectedFile.name;
      if (selectedFile && selectedFile.size > 5000000) {
        this.$message.error("Arquivo muito grande. Tamanho máximo: 5MB");
      } else {
        this.$emit("pick", selectedFile);
      }
      this.$refs.fileInputElement.value = "";
    }
  }
};
</script>
